import { useEffect } from 'react';
import { Control } from 'react-hook-form';

export const useBasicAuth = (control: Control<any>, enabledBasicAuth: boolean) => {
    useEffect(() => {
        if (!enabledBasicAuth) {
            control.unregister('auth.type');
            control.unregister('auth.login');
            control.unregister('auth.password');
        } else {
            control.register('auth.type', { value: 'Basic' });
        }
    }, [enabledBasicAuth, control]);
};